import React from "react";
import { Link } from "react-router";
import classNames from "classnames";
import PropTypes from "prop-types";
import DashboardIcon from "components/icons/DashboardIcon";
import TransactionsIcon from "components/icons/TransactionsIcon";
import WalletIcon from "components/icons/WalletIcon";
import MerchantsIcon from "components/icons/MerchantsIcon";
import {
  USA_HOST,
  SG_HOST,
  MY_HOST,
  VN_HOST,
  PH_HOST,
  PH_BUSINESS_HOST,
} from "config";

import "./styles/header.less";
import "./styles/hamburger.less";

export default class Header extends React.Component {
  static propTypes = {
    routes: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
      })
    ).isRequired,
    logout: PropTypes.func.isRequired,
    zapperId: PropTypes.string,
    firstName: PropTypes.string,
    image: PropTypes.string,
    location: PropTypes.object,
    isTransparent: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      openDrawer: false,
      openDrowdown: false,
    };
  }

  toggleDrawer() {
    this.setState({ openDrawer: !this.state.openDrawer });
  }

  unToggleDrawer() {
    this.setState({ openDrawer: false });
  }

  toggleDropdown() {
    this.setState({ openDropdown: !this.state.openDropdown });
  }

  unToggleDropdown() {
    this.setState({ openDropdown: false });
  }

  unToggleAll() {
    this.unToggleDrawer();
    this.unToggleDropdown();
  }

  logout() {
    this.unToggleAll();
    if (this.props.logout) {
      this.props.logout();
    }
  }

  render() {
    let isLoggedIn = this.props.zapperId !== null;
    let firstName = this.props.firstName || null;

    let hasNoLoginRegister =
      document.domain === USA_HOST ||
      document.domain === SG_HOST ||
      document.domain === VN_HOST;

    let hamburgerClass = classNames("hamburger", {
      active: this.state.openDrawer,
    });

    let menuClass = classNames("menu", {
      in: this.state.openDrawer,
    });

    let menuContainerClass = classNames("menu-container", {
      in: this.state.openDrawer,
    });

    let homeClass = classNames("mobile-only", "home", {
      active: typeof this.props.routes[1].path === "undefined",
      hide: isLoggedIn,
    });

    let howitworksClass = classNames("how-it-works", {
      hide: this.props.routes[1].path === "business",
      active: this.props.routes[1].path === "how-it-works",
    });

    let contactClass = classNames("contact", {
      hide: this.props.routes[1].path === "business",
      active: this.props.routes[1].path === "contact",
    });

    let merchantsClass = classNames("merchants", {
      hide: this.props.routes[1].path === "business" || isLoggedIn,
      active: this.props.routes[1].path === "merchants",
    });

    let registerClass = classNames("register", {
      hide:
        this.props.routes[1].path === "business" ||
        isLoggedIn ||
        hasNoLoginRegister,
      active: this.props.routes[1].path === "register",
      register: true,
    });

    let loginClass = classNames("login", {
      hide:
        this.props.routes[1].path === "business" ||
        isLoggedIn ||
        hasNoLoginRegister,
      active: this.props.routes[1].path === "login",
    });

    let dashboardClass = classNames("dashboard", {
      hide: this.props.routes[1].path === "business" || !isLoggedIn,
    });

    let myAccountClass = classNames("my-account", {
      hide: this.props.routes[1].path === "business" || !isLoggedIn,
    });

    let logoutClass = classNames("logout", {
      hide: this.props.routes[1].path === "business" || !isLoggedIn,
    });

    let businessClass = classNames("business", {
      hide: this.props.routes[1].path === "business" || isLoggedIn,
      business: true,
    });

    let membersClass = classNames({
      hide: this.props.routes[1].path !== "business",
      business: true,
    });

    let subContentClass = classNames("subcontent", {
      hide: this.props.routes[1].path === "business" || !isLoggedIn,
    });

    let subDashboardClass = classNames({
      active: this.props.routes[1].path === "dashboard",
    });

    let subTransactionsClass = classNames({
      active: this.props.routes[1].path === "transactions",
    });

    let subWalletClass = classNames({
      active: this.props.routes[1].path === "wallet",
    });

    let subMerchantsClass = classNames({
      active: this.props.routes[1].path === "merchants",
    });

    let dropdownMenuClass = classNames("drop-down-menu", {
      in: this.state.openDropdown,
    });

    let dropdownButtonClass = classNames("drop-down-button", {
      hide: !isLoggedIn,
    });

    let headerClass = classNames({
      in: this.state.openDrawer,
      transparent: this.props.isTransparent,
    });

    return (
      <div id="header" className={headerClass}>
        <div className="content">
          <Link className="logo" to="/" />
          <div className={menuContainerClass}>
            <div id="menu" className={menuClass}>
              <Link
                onClick={() => this.unToggleAll()}
                className={homeClass}
                to="/"
              >
                Home
              </Link>
              <Link
                onClick={() => this.unToggleAll()}
                className={howitworksClass}
                to="/how-it-works"
              >
                How It Works
              </Link>
              <Link
                onClick={() => this.unToggleAll()}
                className={contactClass}
                to="/contact"
              >
                Contact
              </Link>
              <Link
                onClick={() => this.unToggleDrawer()}
                className={merchantsClass}
                to="/merchants"
              >
                Merchants
              </Link>
              <Link
                onClick={() => this.unToggleDrawer()}
                className={registerClass}
                to="/register"
              >
                Free Sign Up
              </Link>
              <Link
                onClick={() => this.unToggleDrawer()}
                className={loginClass}
                to="/login"
              >
                Login
              </Link>

              <Link
                onClick={() => this.unToggleDrawer()}
                className={dashboardClass}
                to="/dashboard"
              >
                <div className="border" />
                <img src={this.props.image} />
                {firstName}
              </Link>
              <button
                className={dropdownButtonClass}
                tabIndex="2"
                onClick={() => this.toggleDropdown()}
              />

              <div className={dropdownMenuClass} tabIndex="1">
                <div className="arrow" />
                <div className="container">
                  <Link
                    className={myAccountClass}
                    to="/profile"
                    onClick={() => this.unToggleAll()}
                  >
                    My Account
                  </Link>

                  <a
                    onClick={() => {
                      this.logout();
                      this.unToggleAll();
                    }}
                    className={logoutClass}
                  >
                    Logout
                  </a>
                </div>
              </div>
              <Link
                onClick={() => this.unToggleDrawer()}
                className={businessClass}
                to={
                  document.domain === PH_HOST ? PH_BUSINESS_HOST : "/business"
                }
                target={document.domain === PH_HOST ? "_blank" : ""}
              >
                For Business
              </Link>
              <Link
                onClick={() => this.unToggleDrawer()}
                className={membersClass}
                to="/"
              >
                For Members
              </Link>
            </div>
          </div>

          <button
            className={hamburgerClass}
            onBlur={() => this.unToggleDrawer()}
            onClick={() => this.toggleDrawer()}
          >
            <span>=</span>
          </button>
        </div>

        <div className={subContentClass}>
          <div className="submenu">
            <div className="item">
              <Link
                className={subDashboardClass}
                to="/dashboard"
                onClick={() => this.unToggleAll()}
              >
                <div className="icon">
                  <DashboardIcon />
                </div>
                <span>Dashboard</span>
              </Link>
            </div>
            <div className="item">
              <Link
                className={subTransactionsClass}
                to="/transactions"
                onClick={() => this.unToggleAll()}
              >
                <div className="icon">
                  <TransactionsIcon />
                </div>
                <span>Transactions</span>
              </Link>
            </div>
            <div className="item">
              <Link
                className={subWalletClass}
                to="/wallet"
                onClick={() => this.unToggleAll()}
              >
                <div className="icon">
                  <WalletIcon />
                </div>
                <span>Wallet</span>
              </Link>
            </div>
            <div className="item">
              <Link
                className={subMerchantsClass}
                to="/merchants"
                onClick={() => this.unToggleAll()}
              >
                <div className="icon">
                  <MerchantsIcon />
                </div>
                <span>Merchants</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/Header.js